import { jucyInsights } from '#/lib/jucyInsights';
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    service: 'nakuru',
    applicationId: '7680717a-4f69-4455-8626-503bee55d05a',
    clientToken: 'pub49f11c85b82453e9214fd095ba2376d7',

    site: 'us5.datadoghq.com',
    env: process.env.NEXT_PUBLIC_ENV || 'dev',
    version: process.env.NEXT_PUBLIC_APP_VERSION || undefined,
    trackSessionAcrossSubdomains: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    startSessionReplayRecordingManually: true,
    trackUserInteractions: true,
    storeContextsAcrossPages: true,
    usePartitionedCrossSiteSessionCookie: true,
    trackResources: true,
    trackLongTasks: true,
    sessionPersistence: 'local-storage',
    enableExperimentalFeatures: ['feature_flags'],
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [(url) => jucyInsights.shouldTraceUrl(url)],
    proxy: (options) => `https://${jucyInsights.resolveInsightsDomain(window.location.href)}/ingest${options.path}?${options.parameters}`,
});
